import BtnStart from './btn-start'

export default BtnStart